import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class TelemetriaService {
  private appInsights: ApplicationInsights | null = null;

  public inicializar(): void {
    if (this.appInsights) return;
    if (!environment.appInsightsConnectionString) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsightsConnectionString,
        enableAutoRouteTracking: true,
        disableAjaxTracking: true,
        disableExceptionTracking: true,
        samplingPercentage: environment.appInsightsSampling,
      },
    });

    this.appInsights.loadAppInsights();
  }

  public trackError(error: Error, props?: Record<string, string>): void {
    this.appInsights?.trackException({ exception: error }, props);
  }

  public trackEvento(nombre: string, props?: Record<string, string>): void {
    this.appInsights?.trackEvent({ name: nombre }, props);
  }
}
